import React from "react";
import deliveryfff from '../../assets/images/deliveryfff.png'; 
import { useTranslation } from 'react-i18next';

function Billtitle() {
const { t } = useTranslation();
  return (
    <div className="Favourites_title">
        <div className="Favourites_title_l">
           <img className="deliveredimgmenu" src={deliveryfff} alt="" width="43" height="33" />
           <h2>{t('orderinprgess_txt')}</h2>
        </div>
        
      </div>
    );
}

export default Billtitle;
